module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/plan02_point-95d9880bc47de7b9262027854a62ad4b.jpg";